import { combineReducers } from "@reduxjs/toolkit"
import LoginReducer from "./LoginReducer"
import LoginForgetPassReducer from "./LoginForgetPassReducer"
import LoginResetPassReducer from "./LoginResetPassReducer"
import StoreListReducer from "./StoreListReducer"
import CustomerListReducer from "./CustomerListReducer"
import VendorProfileReducer from "./VendorProfileReducer"
import VendorAddressReducer from "./VendorAddressReducer"
import productList from "./ProductListReducer"
import CategoryList from './CategoryReducer'
import FlagshipListReducer from "./FlagshipListReducer"
import BrandReducer from "./BrandReducer"
import TopSellingProductReducer from "./TopSellingProductReducer"
import RequestCategoriesReducer from "./RequestCategoriesReducer"
import VouchersListReducer from "./ActiveVouchersListReducer"
import InactiveVouchersListReducer from "./InactiveVouchersListReducer"
import RequestBrandReducer from "./RequestBrandReducer"
import AttributesReducer from "./AttributesReducer"
import RequestAttributesReducer from "./RequestAttributesReducer"
import ActiveAdsReducer from "./ActiveAdsReducer"
import InactiveAdsReducer from "./InactiveAdsReducer"
import MostSpentCustomersReducer from "./MostSpentCustomersReducer"
import TopCustomersReducer from "./TopCustomersReducer"
import OrderListReducer from "./OrderListReducer"
import VendorAnalyticsReducer from "./VendorAnalyticsReducer"
import UsersAnalyticsReducer from "./UsersAnalyticsReducer"
import OrdersAnalyticsReducer from "./OrdersAnalyticsReducer"
import PickupAnalyticsReducer from "./PickupAnalyticsReducer"
 
 

const rootReducer = combineReducers({
	 loginInfo:LoginReducer,
	 loginForgetPass:LoginForgetPassReducer,
	 loginResetPass:LoginResetPassReducer,
	 storeList: StoreListReducer,
	 customerList:CustomerListReducer,
	 vendorProfile: VendorProfileReducer,
	 vendorAddress: VendorAddressReducer,
	 productList: productList,
	 categoryList: CategoryList,
	 flagshipList:FlagshipListReducer,
	 topSellingProductList:TopSellingProductReducer,
	 requestCategories: RequestCategoriesReducer,
	 vouchersList:VouchersListReducer,
	 inActiveVouchersList:InactiveVouchersListReducer,
	 brandList:BrandReducer,
	 requestBrand: RequestBrandReducer,
	 attributes:AttributesReducer,
	 requestAttributes:RequestAttributesReducer,
	 activeAds:ActiveAdsReducer,
	 inactiveAds:InactiveAdsReducer,
	 mostSpentCustomers:MostSpentCustomersReducer,
	 topCustomers:TopCustomersReducer,
	 orderlist:OrderListReducer,
	 vendorAnalytics:VendorAnalyticsReducer,
	 usersAnalytics:UsersAnalyticsReducer,
	 ordersAnalytics: OrdersAnalyticsReducer,
	 pickupAnalytics:PickupAnalyticsReducer,
 

})

export default rootReducer
